import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import CollapsibleSection from './CollapsibleSection.vue'


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'OptionalCollapsible' },
  __name: 'OptionalCollapsible',
  props: {
    enabled: { type: Boolean },
    title: {},
    testId: {},
    summary: { default: undefined },
    defaultExpanded: { type: Boolean, default: true }
  },
  setup(__props: any) {

/**
 * Acordeão que só existe quando `enabled`. Desligado, renderiza apenas o slot — o
 * DOM fica idêntico ao de antes. É o que deixa o Detalhes do Plantão ganhar os
 * acordeões "Médico" e "Valores do plantão" no celular sem mexer no desktop.
 */




return (_ctx: any,_cache: any) => {
  return (_ctx.enabled)
    ? (_openBlock(), _createBlock(CollapsibleSection, {
        key: 0,
        title: _ctx.title,
        "test-id": _ctx.testId,
        summary: _ctx.summary,
        "default-expanded": _ctx.defaultExpanded,
        "touch-target": "",
        class: "rounded-lg border border-lightGray30 px-3 py-3 md:px-4"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["title", "test-id", "summary", "default-expanded"]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})